/**
 * An even better animation frame.
 *
 * @copyright Oleg Slobodskoi 2016
 * @website https://github.com/kof/animationFrame
 * @license MIT
 */

module.exports = require('./lib/animation-frame')



//////////////////
// WEBPACK FOOTER
// ./~/animation-frame/index.js
// module id = 4
// module chunks = 0